import { useState } from 'react';
import Settings from 'components/settings/settings';
import { Route, MemoryRouter } from 'react-router-dom';
import Home from '../components/home'
import Header from '../components/header';
import Footer from 'components/footer';
import DiskStatus from 'components/disk_status';
import Antiviruses from 'components/antiviruses';
import ChooseFile from 'components/choose_file';
import ScanFile from 'components/scan_file';
import Docker from 'components/docker';
import ScanResult from 'components/scan_result';

export default function Router() {

    return (
        (
            <MemoryRouter>
             {/*    <Header /> */}
                <Route exact path='/' component={Home} />
                <Route exact path='/settings' component={Settings} />
                <Route exact path='/disk' component={DiskStatus} />
                <Route exact path='/chooseFile' component={ChooseFile} />
                <Route exact path='/scanfile' component={ScanFile} />
                <Route exact path='/docker' component={Docker} />
                <Route exact path='/scanResult' component={ScanResult} />
              {/*   <Footer /> */}
            </MemoryRouter>
        )
    )
}
